import {
  audioChecklist,
  briefsChecklist,
  designsChecklist,
  designsHardcodedChecklist,
  hardcodedAssetsChecklist,
  pluginsChecklist,
} from "../Main/QaProcesses/QaChecklistConfig";

const rowsToSeedItems = (rows) =>
  rows
    .map((row) => ({
      item: String(row?.text ?? "").trim(),
      completed: false,
    }))
    .filter((row) => row.item.length > 0);

/**
 * Built-in QA admin template seed: section names match legacy checklist groupings.
 * `completed` is ignored when persisting (progress is per-asset elsewhere).
 */
export const getBuiltInQaAdminChecklistSeed = () => [
  { section: "BRIEFING", items: rowsToSeedItems(briefsChecklist) },
  { section: "AUDIO", items: rowsToSeedItems(audioChecklist) },
  {
    section: "DESIGN",
    items: rowsToSeedItems([...designsChecklist, ...designsHardcodedChecklist]),
  },
  {
    section: "CODING",
    items: rowsToSeedItems([...pluginsChecklist, ...hardcodedAssetsChecklist]),
  },
];
